import { EncryptionType } from './core/crypto-core/types';
import { CollectionItem } from './core/secure-json-collection/types';
import { SecureJsonEncryptor } from './core/secure-json-encryptor';

export const secureJsonEncryptItem = (item: CollectionItem, encryptionType: EncryptionType) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const prepareObject = (value: any): any => {
    if (value instanceof Map) {
      return {
        __dataType: 'Map',
        value: Array.from(value.entries()).map(([key, val]) => [key, prepareObject(val)]),
      };
    } else if (value instanceof Set) {
      return {
        __dataType: 'Set',
        value: Array.from(value.values()).map(prepareObject),
      };
    } else {
      return value;
    }
  };

  const sjEncryptor = new SecureJsonEncryptor(encryptionType);
  const encryptedItem = sjEncryptor.encryptItem(item);

  const data: CollectionItem = {
    encryptedData: encryptedItem.encryptedData,
    encryptedSymmetricKeys: prepareObject(encryptedItem.encryptedSymmetricKeys),
    permissions: prepareObject(encryptedItem.permissions),
  };

  if (item.signature) {
    data.signature = item.signature;
  }

  return data;
};
